import * as React from 'react';
import { Control, Errors } from 'react-redux-form';

import { hasValue, getDefaultErrorMessages, isValidAccountNumber, isValidRoutingNumber } from '@common/validators';

export function PaymentACHComponent(props: { modelPathPrefix: string }): JSX.Element {
  return (
    <>
      <div className="row">
        <div className="form-control col-md-4">
          <label htmlFor={props.modelPathPrefix.concat('.routingNumber')}>Routing Number</label>
          <Control.text
            id={props.modelPathPrefix.concat('.routingNumber')}
            model={props.modelPathPrefix.concat('.routingNumber')}
            validators={{ isValidRoutingNumber, required: hasValue }}
          />
          <Errors
            className="error"
            messages={getDefaultErrorMessages()}
            model={props.modelPathPrefix.concat('.routingNumber')}
            show={{ touched: true, focus: false }}
          />
        </div>
        <div className="form-control col-md-4">
          <label htmlFor={props.modelPathPrefix.concat('.accountNumber')}>Account Number</label>
          <Control.text
            id={props.modelPathPrefix.concat('.accountNumber')}
            model={props.modelPathPrefix.concat('.accountNumber')}
            validators={{ isValidAccountNumber, required: hasValue }}
          />
          <Errors
            className="error"
            messages={getDefaultErrorMessages()}
            model={props.modelPathPrefix.concat('.accountNumber')}
            show={{ touched: true, focus: false }}
          />
        </div>
      </div>
    </>
  );
}



// WEBPACK FOOTER //
// ./src/payment/_components/payment-ach.component.tsx